module.exports = __webpack_public_path__ + "284ccc70c9d362686b2ed991ed081a24.png";